import React from 'react'
import styled from 'styled-components'

export const Pricing = () => {
  return (
    <Section>
      <Sub>Pricing Plans</Sub>
      <Desc>Choose a plan that fits your business needs.</Desc>
      <Plans>
        <Plan>
          <Title>Starter</Title>
          <Price>$49/mo</Price>
          <FeatureList>
            <Feature>✅ AI Voice Assistance</Feature>
            <Feature>✅ 24/7 Support</Feature>
            <Feature>✅ Basic Analytics</Feature>
          </FeatureList>
          <Button>Select Plan</Button>
        </Plan>
        <Plan featured>
          <Title>Business</Title>
          <Price>$99/mo</Price>
          <FeatureList>
            <Feature>✅ Everything in Starter</Feature>
            <Feature>✅ Advanced Analytics</Feature>
            <Feature>✅ Custom AI Training</Feature>
          </FeatureList>
          <Button>Get Started</Button>
        </Plan>
        <Plan>
          <Title>Enterprise</Title>
          <Price>Custom</Price>
          <FeatureList>
            <Feature>✅ Dedicated AI Agent</Feature>
            <Feature>✅ Custom Integrations</Feature>
            <Feature>✅ Priority Support</Feature>
          </FeatureList>
          <Button>Contact Us</Button>
        </Plan>
      </Plans>
    </Section>
  )
}

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 10%;
  gap: 15px;
  padding: 40px 20px;
  width: 80%;
  margin: auto;
`

const Sub = styled.h2`
  font-family: raritas, sans-serif;
  color: #034C53;
  font-size: 24px;
  font-weight: 600;
`

const Desc = styled.p`
  color: #595959;
  font-size: 18px;
  font-weight: 400;
  max-width: 600px;
`

const Plans = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
`

const Plan = styled.div`
  background-color: #EEF1DA;
  padding: 30px;
  border-radius: 16px;
  width: 30%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
`

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #034C53;
`

const Price = styled.p`
  font-size: 24px;
  font-weight: 700;
  color: #034C53;
  margin: 10px 0;
`

const FeatureList = styled.div`
  text-align: left;
  margin: 15px 0;
`

const Feature = styled.p`
  font-size: 16px;
  color: #595959;
`

const Button = styled.button`
  background-color: #034C53;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #022F35;
  }
`
